import { ValidatorFn, FormControl, ValidationErrors } from "@angular/forms";
import { RegexValidator } from "./regex-validator.function";

export function IntegerValidator(): ValidatorFn {

    const integerRegex = "^[0-9]+$";
    
    return (control: FormControl): ValidationErrors | null => {
        return RegexValidator(control, integerRegex);
    }
}
